import {
  getHireInterviewsRetrieveQueryOptions,
  getHireJobsWorkingInterviewsRetrieveQueryOptions,
} from "@sidegigllc/api/client";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = { jobId: string; enabled: boolean };

export const workingInterviewsQuery = ({ jobId, enabled }: QueriesInput) =>
  getHireJobsWorkingInterviewsRetrieveQueryOptions(jobId, { query: { enabled } });

/** A done seat's interview, for whether the tryout happened; off while the card already holds it. */
export const seatInterviewQuery = ({ interviewId, enabled }: { interviewId: string | null; enabled: boolean }) =>
  getHireInterviewsRetrieveQueryOptions(interviewId ?? "", { query: { enabled: enabled && interviewId !== null } });

// Gated on a per-location flag only the component can read; warming would 404 while it's off.
export const queries = (): Array<WarmableQuery> => [];
